import { defineMessages } from 'react-intl'

export default defineMessages({
    unknownError: {
        id: 'errors.unknownError',
        defaultMessage: 'Не удалось совершить действие.',
    },
    noSelectedVehicle: {
        id: 'errors.noSelectedVehicle',
        defaultMessage: 'Не удалось начать подбор отряда: не выбрана техника для боя.',
    },
    selectedVehiclesNotReady: {
        id: 'errors.selectedVehiclesNotReady',
        defaultMessage: 'Не удалось начать подбор отряда: выбранная техника не готова к бою.',
    },
})



// WEBPACK FOOTER //
// ./errors.js